export interface ProductVideo {
  label: string
  url: string
}

export interface ProductVideoGroup {
  title: string
  videos: readonly ProductVideo[]
}

// Jaron (Slack, 2026-07-20): "I want video links on the customer report to
// show videos of what we have" — a fixed list, not tied to a customer's
// selected products. Source files hosted in Luis's public Drive folder
// "Videos HomeCam" (mirrors the private closers Drive folder structure).
//
// Jaron (Slack #development-dpt, 2026-10-08, ticket 13241311120): rename so
// reps know what each video is before opening it, one video of each type, and
// an Ads section. Removed: 360° View & NVR and Turret Camera & Perimeter
// Protection (his call), S4 Max (same video as "How It Works"), Install 03
// (basically Install 02) and Install 06 ("doesn't exist"). "HC Equipment" is
// "Smart Panel Presentation": his name for it says "Alarm", a word that can't
// appear on the customer report (Monday 12824335937).
export const productVideoGroups: readonly ProductVideoGroup[] = [
  {
    title: 'Ads',
    videos: [
      {
        label: 'Homecam Security Systems Ad (EN)',
        url: 'https://drive.google.com/file/d/1i2XW0fqwdGQCXwUNwAxeQwLn_gdAUPVi/view?usp=drive_link',
      },
      {
        label: 'Homecam Security Systems Ad (ES)',
        url: 'https://drive.google.com/file/d/1MXTVzy-bhu5J0BnEgDr5806L_-6eAIQX/view?usp=drive_link',
      },
      {
        // Was "Qué es un Sistema CCTV".
        label: 'Spanish CCTV Ad',
        url: 'https://drive.google.com/file/d/1U8xFfoBsnG8ZphezoArWRca3PeuXd0lJ/view?usp=drive_link',
      },
      {
        // English counterpart of the one above; Jaron's list didn't rename it.
        label: "What's a CCTV System",
        url: 'https://drive.google.com/file/d/1u_7lCQNr_PPKkOyljXsBcfI5kBRit22g/view?usp=drive_link',
      },
    ],
  },
  {
    title: 'General',
    videos: [
      {
        // Was "Eufy Cams".
        label: 'Solar S4 Camera',
        url: 'https://drive.google.com/file/d/1GHA_GEqiMGUUUr3PZjOq-Gl4GRWRuVIL/view?usp=drive_link',
      },
      {
        // Was "How It Works".
        label: 'S4 Max Siren Example',
        url: 'https://drive.google.com/file/d/1lhDtPVCgH4Yhr-ECqOspm2epn19T7-9o/view?usp=drive_link',
      },
      {
        // Was "View Test".
        label: 'CCTV TV Example',
        url: 'https://drive.google.com/file/d/1OVXQp1ky4RHrtUyCZpAXoF7CGIbh97oP/view?usp=drive_link',
      },
    ],
  },
  {
    title: 'Features',
    videos: [
      {
        label: 'Facial Recognition',
        url: 'https://drive.google.com/file/d/1j2ahCYO4R2dO3SeE9B9eNxxxrDCr4PEe/view?usp=drive_link',
      },
      {
        label: 'Smart Panel, Voice, Lights & Zoom',
        url: 'https://drive.google.com/file/d/1Y-4Hkiji2Th1xaj6yOg_pJ96WgrXU6Su/view?usp=drive_link',
      },
      {
        // Was "HC Equipment".
        label: 'Smart Panel Presentation',
        url: 'https://drive.google.com/file/d/1h0uk1tIkMEApDMsDTY3Ht9KETCVeu1S6/view?usp=drive_link',
      },
      {
        // Was "NVR".
        label: 'NVR/CCTV Overview',
        url: 'https://drive.google.com/file/d/1JFphcjQIpZ17WbCbPaJlE16xN1wR5I9_/view?usp=drive_link',
      },
    ],
  },
  {
    title: 'Installs',
    videos: [
      {
        // Was "Eufy S4 Max Install".
        label: 'S4 Max Camera Overview',
        url: 'https://drive.google.com/file/d/1yjgy-hNch5F6jyIHOLITMnJkO0OPNcli/view?usp=drive_link',
      },
      {
        // Was "Install 01".
        label: 'CCTV Full Install',
        url: 'https://drive.google.com/file/d/1CfiSVkrAE-aq4a93VUW5btuwhDKN_lmk/view?usp=drive_link',
      },
      {
        // Was "Install 02".
        label: 'S4 Max Install',
        url: 'https://drive.google.com/file/d/1tZOz4IQiClv7QBQTd192YrIOSMuSNemH/view?usp=drive_link',
      },
      {
        // Was "Install 04".
        label: 'Wiring/S4 Max Install',
        url: 'https://drive.google.com/file/d/1CQdS7wZmIi9dUgZ8XhcsB6MOdc3Bpscs/view?usp=drive_link',
      },
      {
        // Was "Install Step by Step Process".
        label: 'Full Install (Full Length Version)',
        url: 'https://drive.google.com/file/d/1NApIn7L5z1561p8tCqOtUnVVZQSNOyBJ/view?usp=drive_link',
      },
    ],
  },
]
